module.exports = __webpack_public_path__ + "static/schall_im_schilf-d4e8c4d847bfec357b98c49ed465100d.jpg";